// ADMINS
const adminList = [

    'roneill@tcelect.net',
    'ckruger@tcelect.net',
    'chowley@tcelect.net',
    'cdawson@tcelect.net'
]

//TOOLS
const toolList = [
    'Email Generator',
    'Chatbot',
    'Cable Run Optimizer',
    'GO Tracker',
    'Personnel Database',
    'Tool Usage Statistics',
    'Drone Captures',
    'EIT Dashboard',
    'Training',
    'Executive Dashboards',
    'Monthly Executive Reports'
]

module.exports = {
    adminList, 
    toolList
}


